import {
  faTimes,
  faUndo,
  faArrowRight,
} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { yupResolver } from '@hookform/resolvers/yup';
import React, { useState } from 'react';
import { FormProvider, useForm } from 'react-hook-form';
import { i18n } from 'src/i18n';
import yupFormSchemas from 'src/modules/shared/yup/yupFormSchemas';
import * as yup from 'yup';
import TextAreaFormItem from 'src/view/shared/form/items/TextAreaFormItem';
import { useSelector } from 'react-redux';
import authSelectors from 'src/modules/auth/authSelectors';
import { getHistory } from 'src/modules/store';

function PromptParamsForm(props) {
  const { saveLoading, parameters, promptName } = props;

  const user = useSelector(authSelectors.selectSignedIn);

  const [initialValues, setInitialValues] = useState({
    whoAmI: parameters.whoAmI,
    withWhom: parameters.withWhom,
    topic: parameters.topic,
  });

  // const capitalize = (string: string) => {
  //   return string.charAt(0).toUpperCase() + string.slice(1).toLowerCase();
  // };

  const generateSchema = (fields) => {
    return yup.object().shape({
      whoAmI: yupFormSchemas
        .string(i18n('entities.prompt.fields.whoAmI'), {})
        .required(),
      withWhom: yupFormSchemas
        .string(i18n('entities.prompt.fields.withWhom'), {})
        .required(),
      topic: yupFormSchemas
        .string(i18n('entities.prompt.fields.topic'), {})
        .required(),
    });
  };

  const form = useForm({
    resolver: yupResolver(generateSchema(parameters)),
    mode: 'all',
    defaultValues: initialValues,
  });

  const onSubmit = (values) => {
    if (user === false) {
      const data = { ...values, promptName };
      localStorage.setItem('chat-params', JSON.stringify(data));
      getHistory().push('/auth/signin');
    } else {
      props.onSubmit(props.record?.id, values);
      typeof window !== 'undefined' && localStorage.removeItem('chat-params');
    }
  };

  const onReset = () => {
    Object.keys(initialValues).forEach((key) => {
      form.setValue(key, initialValues[key]);
    });
  };

  return (
    <FormProvider {...form}>
      <form onSubmit={form.handleSubmit(onSubmit)}>
        <div className='w-full mt-4 sm:w-md md:w-md lg:w-md'>
          <TextAreaFormItem
            name='whoAmI'
            label={i18n('entities.prompt.fields.whoAmI')}
            required={true}
            // @ts-ignore
            onChange={(e) =>
              setInitialValues({
                ...initialValues,
                [e.target.name]: e.target.value,
              })
            }
          />
        </div>

        <div className='w-full mt-4 sm:w-md md:w-md lg:w-md'>
          <TextAreaFormItem
            name='withWhom'
            label={i18n('entities.prompt.fields.withWhom')}
            required={true}
            // @ts-ignore
            onChange={(e) =>
              setInitialValues({
                ...initialValues,
                [e.target.name]: e.target.value,
              })
            }
          />
        </div>

        <div className='w-full mt-4 sm:w-md md:w-md lg:w-md'>
          <TextAreaFormItem
            name='topic'
            label={i18n('entities.prompt.fields.topic')}
            required={true}
            // @ts-ignore
            onChange={(e) =>
              setInitialValues({
                ...initialValues,
                [e.target.name]: e.target.value,
              })
            }
          />
        </div>

        <div className='pt-4'>
          {props.onReset && (
            <button
              disabled={saveLoading}
              onClick={onReset}
              className='px-4 py-2 mb-2 mr-2 text-sm tracking-wide text-gray-700 transition-colors duration-200 transform bg-white border border-gray-300 rounded-md disabled:opacity-50 disabled:cursor-default dark:border-gray-800 dark:bg-gray-800 dark:hover:bg-gray-600 dark:text-white hover:bg-gray-100 focus:outline-none focus:bg-gray-100'
              type='button'>
              <FontAwesomeIcon className='mr-2' icon={faUndo} />
              {i18n('common.reset')}
            </button>
          )}
          <div className='flex justify-center'>
            {props.onCancel ? (
              <button
                disabled={saveLoading}
                onClick={() => props.onCancel()}
                className='inline-block px-5 py-2 my-2 mr-6 text-sm text-white border border-white rounded-md hover:bg-gray-300 focus:outline-none dark:hover:text-black'
                type='button'>
                {i18n('common.close')}
                <FontAwesomeIcon icon={faTimes} className='ml-2' />
              </button>
            ) : null}

            <button
              className='inline-block border-green-500 border-2 rounded-md px-4 py-2 my-2 mr-4 text-sm text-green-500 hover:text-white hover:bg-green-500 focus:outline-none focus:border-green-500'
              disabled={saveLoading}
              type='button'
              onClick={form.handleSubmit(onSubmit)}>
              {i18n('entities.prompt.parameters.startChat')}
              <FontAwesomeIcon
                className='ml-2'
                size='1x'
                // icon={saveLoading ? faSpinner : faPlayCircle}
                // spin={saveLoading}
                icon={faArrowRight}
              />
            </button>
          </div>
        </div>
      </form>
    </FormProvider>
  );
}

export default PromptParamsForm;
